var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.87504C22 12.672 18.922 15.75 15.125 15.75C14.6867 15.75 14.2582 15.7085 13.8427 15.6301L12.9047 16.6854C12.8168 16.7843 12.7089 16.8635 12.5881 16.9177C12.4673 16.972 12.3364 17 12.204 17H10.75V18.5625C10.75 19.0803 10.3303 19.5 9.8125 19.5H8.25V21.0625C8.25 21.5803 7.83027 22 7.3125 22H2.9375C2.41973 22 2 21.5803 2 21.0625V18.0133C2 17.7647 2.09879 17.5262 2.27457 17.3504L8.59496 11.03C8.37141 10.3521 8.25 9.62777 8.25 8.875C8.25 5.07805 11.328 2.00004 15.125 2C18.9331 1.99996 22 5.06684 22 8.87504ZM15.125 7C15.125 8.03555 15.9645 8.875 17 8.875C18.0355 8.875 18.875 8.03555 18.875 7C18.875 5.96445 18.0355 5.125 17 5.125C15.9645 5.125 15.125 5.96445 15.125 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.9f55d75f1d29aa5c935930b8cb54998e.svg";
export { ForwardRef as ReactComponent };